import DataRequestGuide from '../../components/DataRequestGuide';

const steps = [
    {
        id: 'grok-step-1',
        stepLabel: 'Step 1',
        title: 'Where should you begin?',
        image: process.env.PUBLIC_URL + '/Images/steps/Grok_Step1.png',
        imageAlt: 'Grok home screen with menu icon highlighted',
        body: (
        <>
            Open the Grok app or go to{' '}
            <a href="https://grok.com" target="_blank" rel="noreferrer">
            grok.com
            </a>
            , then press on the three horizontal bars at the top left of the screen.
            (If the side menu is already visible, you can skip this step.)
        </>
        ),
    },
    {
        id: 'grok-step-2',
        stepLabel: 'Step 2',
        title: 'Go to settings',
        image: process.env.PUBLIC_URL + '/Images/steps/Grok_Step2.png',
        imageAlt: 'Settings option highlighted in Grok menu',
        body: (
        <>
            Click on your profile icon, located at the bottom left of the sidebar. 
            In the pop-up menu, click on <strong>Settings</strong>.
        </>
        ),
    },
    {
        id: 'grok-step-3',
        stepLabel: 'Step 3',
        title: 'Open Data Controls',
        image: process.env.PUBLIC_URL + '/Images/steps/Grok_Step3.png',
        imageAlt: 'Data Controls button highlighted in settings',
        body: (
        <>
            In the settings panel, press the <strong>Data Controls</strong> tab. 
        </>
        ),
    },
    
    {
        id: 'grok-step-4',
        stepLabel: 'Step 4',
        title: 'Export your data',
        image: process.env.PUBLIC_URL + '/Images/steps/Grok_Step4.png',
        imageAlt: 'Export Account Data highlighted in Data Controls',
        body: (
        <>
            In the Data Controls menu, click on <strong>Export</strong> under the setting <strong>Export Account Data</strong>. 
            You will be redirected to a new page/menu.
        </>
        ),
    },
    {
        id: 'grok-step-5',
        stepLabel: 'Step 5',
        title: 'Go to Data Settings and Request download',
        image: process.env.PUBLIC_URL + '/Images/steps/Grok_Step5.png',
        imageAlt: 'Data Settings button highlighted in Data Controls',
        body: (
        <>
            In the new page/menu, select the <strong>Data</strong> panel. Then click on <strong>Download</strong> under the setting <strong>Download Account Data</strong>. 
        </>
        ),
        
    },
    {   
        id: 'grok-step-6',
        stepLabel: 'Step 6',
        title: 'Confirmed download',
        image: process.env.PUBLIC_URL + '/Images/steps/Grok_Step6.png',
        imageAlt: 'Confirmed Download dialog',
        body: (
        <>
            A pop-up window will appear confirming your download request. 
            You will receive an email with a download link to your registered email address within a few minutes to a few hours.
        </>
        ),
    },
           
];


const GrokRequest = () => {
    return (
        <DataRequestGuide
        title="How to Request Your Grok Data"
        intro="Follow these steps to export a copy of your Grok data, which you can then donate through this website."
        steps={steps}
        />
    );
};

export default GrokRequest;